import { logicRegisterSupplier } from '../../../logic/api/supplier';

export const registerSupplier = (data) => dispatch => {
    dispatch({
        type: 'SUPPLIER:REGISTER'
    });

  logicRegisterSupplier(data)
    .then((res) => {
        if(res.error)
            dispatch(registerSupplierFail(res.error));
        else {
            dispatch(registerSupplierSuccess());
        }
    })
    .catch((err) => dispatch(registerSupplierFail(err)));
};

const registerSupplierSuccess = () => ({
    type: 'SUPPLIER:REGISTER-SUCCESS'
});

const registerSupplierFail = (err) => ({
    type: 'SUPPLIER:REGISTER-ERROR',
    err
});

export default function supplierReducer(state = {status:false}, action) {
  switch(action.type) {
    case 'SUPPLIER:REGISTER-SUCCESS': {
      return {
        ...state,
        status: true
    };
    }

    case 'SUPPLIER:REGISTER-ERROR': {
      return {
        ...state,
        err: action.err
    };
    }

    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Supplier/redux/supplierAction.js
 **/